module.exports = __webpack_public_path__ + "static/media/niebieski_normal.ee0e6519.png";